import {createSlice} from "@reduxjs/toolkit";
import {apiCall} from "./apiAction";

const slice = createSlice({
    name: 'mahsulot',
    initialState: {
        mahsulotlar: [],
        count: 0,
        total_pages: 1,
        message: false,
        mahsulot_single: false,
    },
    reducers: {
        getAll:      (state, action) => { state.mahsulotlar = action.payload.results; state.count = action.payload.count; state.total_pages = action.payload.total_pages },
        getOne:      (state, action) => { state.mahsulot_single = action.payload },
        saveMahsulot:(state, action) => { state.mahsulotlar.unshift(action.payload); state.message = true },
        editMahsulot:(state, action) => { state.mahsulotlar = state.mahsulotlar.map(i => i.id === action.payload.id ? action.payload : i); state.message = true },
        deleteMahsulot: (state, action) => { state.mahsulotlar = state.mahsulotlar.filter(i => i.id !== action.payload.id); state.message = 'deleted' },
        messageReset:(state) => { state.message = false },
        messageFail: (state) => { state.message = 'error' },
    }
})

export default slice.reducer
export const {messageReset} = slice.actions

export const getMahsulotlar = (page=1, pageSize=20, search='', regionId='', viloyatId='', tab='', category='') => apiCall({
    url: `mahsulot/?page=${page}&page_size=${pageSize}${search?`&search=${search}`:''}${regionId?`&region_id=${regionId}`:''}${viloyatId?`&viloyat_id=${viloyatId}`:''}${tab?`&tab=${tab}`:''}${category?`&category=${category}`:''}`,
    method: 'GET',
    onSuccess: slice.actions.getAll.type,
    onFail:    slice.actions.messageFail.type,
})

export const mahsulotSave = (data) => apiCall({
    url: 'mahsulot/',
    method: 'POST',
    onSuccess: slice.actions.saveMahsulot.type,
    onFail:    slice.actions.messageFail.type,
    data,
})

export const mahsulotEdit = (data) => apiCall({
    url: `mahsulot/${data.id}/`,
    method: 'PUT',
    onSuccess: slice.actions.editMahsulot.type,
    onFail:    slice.actions.messageFail.type,
    data,
})

export const mahsulotDelete = (id) => apiCall({
    url: `mahsulot/${id}/`,
    method: 'DELETE',
    onSuccess: slice.actions.deleteMahsulot.type,
    onFail:    slice.actions.messageFail.type,
})
